<template>
  <Modal v-model="showModal" title='编辑' :mask-closable='false' width='900px'>
    <ul class='modalUl'>



      <li>
        <div class='treeContent'>
          <!-- <tree :treedata='checkSchool' :treekey="treekey" :ischeck='ischeck' @changeClass='changeClass'></tree> -->
        </div>
      </li>
      <li>
        <Form label-position="top" ref='formCustom' v-for='(item, index) in formdata[1]' :key='index'>

          <!-- <FormItem :label="item.title" v-if='item.type=="rangetime"'>
							 <Row  class='pickerview'>
								<DatePicker type="datetime"  v-for='items in item.children'  v-model='items.model' format="yyyy/MM/dd HH:mm"  placeholder="" style="width: 180px"></DatePicker>

							 </Row>


						</FormItem> -->
          <FormItem :label="item.title" v-if='item.type == "rangetime"' :class='[item.block ? "nor" : "act"]'>
            <!-- <DatePicker format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style='width:100%;'></DatePicker> -->
            <DatePicker type="datetimerange" v-model='item.model' format="yyyy/MM/dd HH:mm" placeholder="选择时间"
              style="width: 100%"></DatePicker>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "rangedate"' :class='[item.block ? "nor" : "act"]'>
            <DatePicker type="daterange" v-model='item.model' :split-panels='false' format="yyyy-MM-dd"
              placeholder="选择时间" style="width: 100%"></DatePicker>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "date"' :class='[item.block ? "nor" : "act"]'>
            <DatePicker type="date" v-model='item.model' format="yyyy/MM/dd" placeholder="选择时间" style="width: 100%">
            </DatePicker>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "input"' :class='[item.block ? "nor" : "act"]'>
            <Input v-model="item.model" type='text'></Input>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "time"' :class='[item.block ? "nor" : "act"]'>
            <TimePicker type="time" v-model="item.model" :clearable='true' format='HH:mm' style="width: 100%">
            </TimePicker>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "textarea"' :class='[item.block ? "nor" : "act"]'>
            <Input v-model="item.model" type='textarea' :rows="3"></Input>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "checkbox"' :class='[item.block ? "nor" : "act"]'>
            <Checkbox v-for='(items, indexs) in item.children' :key='indexs' v-model='items.model'
              style='margin-right:40px;'>{{ items.title }}</Checkbox>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "switch"' :class='[item.block ? "nor" : "act"]'>
            <i-switch v-model="item.model" />
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "select"' :class='[item.block ? "nor" : "act"]'>
            <Select v-model="item.model" :placeholder="item.placeholder">
              <Option v-for='items in item.children' :key="items.value" :value="items.value">{{ items.name }}</Option>
            </Select>
          </FormItem>

          <FormItem :label="item.title" v-if='item.type == "selectMutl"' :class='[item.block ? "nor" : "act"]'>
            <Select v-model="item.model" multiple>
              <Option v-for="items in objlist" :value="items.value" :key="items.value">{{ items.name }}</Option>
            </Select>
          </FormItem>
          <FormItem v-if='item.type == "partuser"' label="部门人员">
            <div id='partGroup'>
              <Button type='success' size='small' v-for='(item, index) in partUserData'
                :class="{ 'active': btnAct == index, 'btnNor': item.checkUser > 0 }" :key='item.id' :id="item.id"
                @click='renderUser(item.id, index, item.children)' style='height:20px;'>{{ item.name }}
                <span v-if='item.checkUser > 0'>{{ item.checkUser }}</span></Button>
            </div>
            <Transfer :data="users" :target-keys="targetKeys" style='height:210px' filterable :not-found-text="''"
              :reverse-operation='true' :titles="['待选列表', '已选列表']" @on-change="changeUser"></Transfer>
          </FormItem>
          <FormItem v-if='item.type == "transfer"' :label="item.title">
            <Transfer :data="allUser" :target-keys="targetUser" filterable :not-found-text="''"
              :reverse-operation='true' :titles="['待选列表', '已选列表']" @on-change="changeUser"></Transfer>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "video"'>
            <video id="myvideo" width="350" height="196" :src="item.model" controls="controls" style="display:inline;">
              <source id="tv" type="video/mp4" :src="item.model">
              视频
              </source>
              您的浏览器不支持video标签
            </video>
            <Upload :action='actionUrl' :format="['mp4']" :data='item.pictype' :on-success='upVideo'
              :on-format-error="handleFormatError" ref="videoUpload">
              <Button icon="ios-cloud-upload-outline">上传视频</Button>
            </Upload>
          </FormItem>
          <FormItem :label="item.title" v-if='item.type == "uploadpic"' :class='[item.block ? "nor" : "act"]'>
            <upFile @emitParent='pichandleSuccess' :reloadTmep='reloadTmep' :checkList='selfUrl' :hasName='false'>
            </upFile>
          </FormItem>
          <!-- <FormItem :label="item.title" v-if='item.type=="uploadpic"' :class='[item.block?"nor":"act"]'>

							<viewer :images="selfUrl | formatepic"  class="pics" >
									<img :src="selfUrl" alt="" style='width:60px;height:60px;cursor:pointer'>
							</viewer>
							<div class="demo-upload-list" v-for="item in uploadList">
							        <template v-if="item.status === 'finished'">
							            <img :src="item.url">
							            <div class="demo-upload-list-cover">
							                <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
							                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
							            </div>
							        </template>
<template v-else>
							            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							        </template>
</div>
<Upload action="http://display.incich.com:9208/display-web/UploadImageServlet" :name='item.name'
  :show-upload-list='false' ref="videoUpload" :on-success="pichandleSuccess">
  <Button icon="ios-cloud-upload-outline">上传文件</Button>
</Upload>
</FormItem> -->
          <!-- <FormItem v-if="item.type == 'todolist'" :label='item.title' :class='[item.block ? "nor" : "act"]'>
            <todolist :listdata='item.children' @getlistdata='getlistdata'></todolist>
          </FormItem> -->
          <FormItem :label="item.title" v-if='item.type == "uploadimg"' :class='[item.block ? "nor" : "act"]'>
            <input type="hidden" v-model='item.model'>
            <upImg @upImglist='upImglist' :extradata='item.pictype' :defaultimg='item.model' :defaultname='item.name'
              :max-len='item.len'></upImg>
          </FormItem>
          <FormItem label="上传文件" v-if='item.type == "file"'>
            <upFile @emitParent='getPhotoList' :reloadTmep='reloadTmep' :checkList='formCustom.pic' :hasName='false'>
            </upFile>
          </FormItem>
          <FormItem v-if='item.type == "hidden"' style='display:none'>
            <Input v-for='(items, indexs) in item.children' :key='indexs' v-model="items.model" type='text'></Input>
          </FormItem>

        </Form>
      </li>
    </ul>
    <div slot="footer" style='position:relative;'>
      <!-- 	<Button type="success" class='downcsv' icon="md-arrow-down" @click='downFile'>下载文件</Button> -->
      <!-- <Button type="success" class='downcsv putbox' icon="md-heart-outline" >收藏文件</Button> -->
      <Button type="error" @click='removeItem' class='remove' icon="md-trash" v-if='isnewModal == false'>删除</Button>
      <Button type="default" @click='cancelModal' icon="md-close">取消</Button>
      <Button type="info" @click='saveData' icon="md-checkmark-circle-outline">提交</Button>
      <!-- <Button type="primary" @click='pipeGw' icon="md-checkmark-circle-outline" v-if='targetKeys.length>0'>流转文件</Button> -->
    </div>
  </Modal>
</template>

<script>
import upImg from './upImg'
import upFile from './upFile'

import utils from '../utils/getSchoolData.js'
export default {
  name: 'formItem',
  components: {
    upFile,
    upImg
  },
  mounted () {
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    var that = this
    this.curSchoolid = userInfo.schoolid
    this.getPartData(userInfo.schoolid)
    this.getMember(userInfo.schoolid)
    this.actionUrl = this.baseURL.imgURL
  },
  created () {
    //this.initTable = JSON.parse(JSON.stringify(this.formdata[1]))

  },
  props: ['formdata', 'reloadtmp'],
  watch: {
    reloadtmp (newval, oldval) {

      if (newval != oldval) {

        this.showData()
      }

    },
    targetKeys (newval, oldval) {

      var checkData = {
        departid: [],
        depart: [],
        selusers: [],
        selusersText: [],
      }
      var that = this
      // that.btnAct = -1
      var partUser = this.partUserData
      partUser.map(function (val, index) {
        val['checkUser'] = 0
        var num = 0
        var _child = val['children']
        _child.map(function (child, index) {
          if (newval.indexOf(child['guid']) > -1) {
            num += 1
            if (checkData['selusers'].indexOf(child['guid']) == -1) {
              checkData['selusers'].push(child['guid'])
            }
            if (checkData['selusersText'].indexOf(child['name']) == -1) {
              checkData['selusersText'].push(child['name'])
            }
          }
        })
        if (num > 0) {
          checkData['departid'].push(val['id'])
          checkData['depart'].push(val['name'])
          // that.btnAct = index
        }
        val['checkUser'] = num
      })


      checkData['selusers'] = checkData['selusers'].join(',')
      checkData['selusersText'] = checkData['selusersText'].join(',')
      checkData['departid'] = checkData['departid'].join(',')
      checkData['depart'] = checkData['depart'].join(',')
      this.checkPartUser = checkData
      this.partUserData = partUser
    }

  },
  data () {
    return {
      actionUrl: '',
      isnewModal: true,
      storeimg: [], //临时存储img
      todolistdata: [],
      curSchoolid: -1,
      todolistindex: 1,
      reloadTmep: -1,
      selfUrl: '', //上传logo pic
      targetUser: [],//选中人员
      allUser: [],//学校下用户
      b_part: [], //备用的部门
      b_user: [], //备用的用户
      checkPartUser: {},
      targetKeys: [], // 选中的target
      btnAct: -1, //选中的部门
      users: [], // 选择的人员
      usersid: '', // 选择人员的id
      companyid: '', // 选择部门id
      choseUserGroup: [], //不同组组合在一起的人员
      partUserData: [], //部门加人员数据
      objlist: [{ value: '111', name: '政治' }, { value: '1sdaf', name: '语文' }, { value: '222', name: '地理' }, { value: '2asdfsdfas', name: "数学" }, { value: '333', name: '历史' }, { value: '3cc09312-6696-11ea-a43c-7cd30adab904', name: '健康管理' }, { value: '3sadfsadf', name: "物理" }, { value: '444', name: '英语' }, { value: '4sadfsa', name: '化学' }, { value: '5sadf', name: "生物" }, { value: 'bd80be1c-ec01-11e9-ab18-7cd30adaa218', name: '书法' }, { value: 'c25a4d94-ec01-11e9-ab18-7cd30adaa218', name: '作文' }],
      treekey: -1,
      ischeck: true,
      checkSchool: [],
      showModal: false,
      initTable: [],
      rangeTime: [],
      schoolData: [],
      initSchoolData: [],
      videoUrl: '',
      selfFormData: [
        { type: 'tree', ischeck: true, model: [], name: 'classid' },
        { type: 'rangetime', title: '开始时间~结束时间', children: [{ name: 'begintime', title: '', model: '' }, { name: 'endtime', title: '', model: '' }] },
        { type: 'textarea', title: '欢迎词或考场内容（可手工换行）', name: 'content', model: '' },
        { type: 'input', title: '考试名称（欢迎词时不填）', name: 'ticketno', model: '' },
        { type: 'textarea', title: '准考证号段（欢迎词时不填）', name: 'exam', model: '' },
        { type: 'select', title: '背景', placeholder: '请选择背景', name: 'bgcolor', model: '0', children: [{ title: '淡雅蓝', value: '2' }, { title: '淡雅红', value: '0' }, { title: '党建红', value: '1' }, { title: '淡雅橙', value: '3' }] },
        { type: 'checkbox', title: '显示方式', children: [{ name: 'unshared', title: '独占方式显示（遮挡所有画面）', model: false }] },
        { type: 'hidden', children: [{ name: 'guid', model: '' }, { name: 'oldclassid', model: '' }] },
        { label: '开始时间', prop: 'begintime' },
        { label: '结束时间', prop: 'endtime' },
        { label: '作业标题', prop: 'title' },
        { label: '内容', prop: 'notice' },
        { label: '屏上显示', prop: 'isscreen', type: 'checkbox' },
        { label: '家长可读', prop: 'isparent', type: 'checkbox' },
        { label: '欢迎词或考场内容（可手工换行）', prop: 'content' },
        { label: '准考证号段（欢迎词时不填）（可手工换行）', prop: 'ticketno' },
        { label: '背景', prop: 'bgcolor', type: 'select', value: [{ value: 2, name: "淡雅蓝" }, { value: 0, name: '淡雅红' }, { value: 1, name: '党建红' }, { value: 3, name: '淡雅橙' }] },
        { label: '显示方式', prop: 'unshared', type: 'checkbox', text: '独占方式显示（遮挡所有画面）' },
        { label: '科目', prop: 'type', type: 'select', value: [{ value: '111', name: '政治' }, { value: '1sdaf', name: '语文' }, { value: '222', name: '地理' }, { value: '2asdfsdfas', name: "数学" }, { value: '333', name: '历史' }, { value: '3cc09312-6696-11ea-a43c-7cd30adab904', name: '健康管理' }, { value: '3sadfsadf', name: "物理" }, { value: '444', name: '英语' }, { value: '4sadfsa', name: '化学' }, { value: '5sadf', name: "生物" }, { value: 'bd80be1c-ec01-11e9-ab18-7cd30adaa218', name: '书法' }, { value: 'c25a4d94-ec01-11e9-ab18-7cd30adaa218', name: '作文' }] },
        { label: '视频地址', prop: 'videourl' },
        { label: '考试日期', prop: 'examtime' },
        { label: '备注', prop: 'remark' },
        { label: '成绩文件', prop: 'filename' },
        { label: '相册名称', prop: 'title' },
        { label: '姓名', prop: 'name' },
        { label: '学号', prop: 'stucode' },
        { label: '物理卡号', prop: 'realcard' },
        { label: '宿舍编号', prop: 'dormid' },
        { label: '科目', prop: 'isFee', type: 'select', value: [{ value: '2', name: '未交费' }, { value: '1', name: '已交费' }] },
        { label: '学生姓名', prop: 'studentname' },
        { label: '家长姓名', prop: 'parentname' },
        { label: '家长手机号码', prop: 'phone' },
        { label: '考试名称（欢迎词时不填） ', prop: 'exam' },
        { label: '网络链接（直接跳转） ', prop: 'url' },
        { label: '描述', prop: 'describ' },
      ],
    }
  },


  methods: {
    showData () {
      var that = this
      this.showModal = true
      var param = this.getUrlParam(this.formdata[0][0])
      var url = this.formdata[0][0].split("?")[0]


      if (param['id'] == -1) {
        that.treekey = Math.random()
        that.checkSchool = []
        that.ischeck = this.formdata[1][0]['ischeck']
        that.formateVal(this.formdata[1], -1)
        that.selfUrl = ''
        that.storeimg = []
        that.isnewModal = true
      } else {
        that.isnewModal = false
        this.axios.get(url, { params: param }).then(res => {

          if (res.classids) {
            res.data['classids'] = res.classids
            res.data['classid'] = res.classids.join(",")
          }
          if (res.items) {
            res.data['item'] = res.items
          }
          if (res.users && res.users.length > 0) {
            res.data['selUser'] = res.users
          }
          if (res.success) {
            that.ischeck = this.formdata[1][0]['ischeck']
            that.treekey = Math.random()
            if (that.ischeck) {
              that.checkSchool = res.data.classids
            } else {

              that.checkSchool = String(res.data.classid).split(",")
            }

            that.formateVal(res.data)
          } else {
            that.$Message.warning(res.msg)
          }

        })
      }

    },
    removeItem () {
      var that = this
      var param = this.getUrlParam(this.formdata[0][0])
      var url = this.formdata[0][0].split("?")[0]
      if (param['id'] == -1) {

      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>是否确认删除</p>',
          onOk: () => {
            this.axios.post(this.formdata[0][2], param).then(res => {

              that.$Message.info(res.msg)
              that.showModal = false
              that.$emit('reloadModalData', true)
            })

          },
          onCancel: () => {

          }
        });
      }

    },
    getlistdata (val) {

      this.todolistdata = val
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleAdd (children) {
      this.todolistindex++;
      children.push({
        value: '',
        index: this.index,
        status: 1
      });
    },
    handleRemove (children, index) {

      children.slice(index, 1)
    },
    upImglist (a, b, c) {
      //console.log(a,b,c)
      var _name = a.name
      var pics = a.pics
      var arr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[1]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        arr.push(obj)
      }

      var storeImg = this.storeimg
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }
      this.storeimg = storeImg

    },
    saveData (a) {
      var param = {}
      var that = this
      var postData = this.formdata[1]
      postData.map(function (val, index) {
        switch (val['type']) {
          case 'rangetimes':
            val['children'].map(function (child, idx) {
              param[child['name']] = that.formateTime(child['model'])
            })
            break
          case 'rangetime':
            param['begintime'] = that.formateTime(val['model'][0]) || ''
            param['endtime'] = that.formateTime(val['model'][1]) || ''
            break
          case 'date':
            param[val['name']] = that.formateTime(val['model'], 1)
            break
          case 'checkbox':
            val['children'].map(function (child, idx) {
              var model = child['model'] == true ? 1 : 0
              param[child['name']] = model
            })
            break
          case 'hidden':
            val['children'].map(function (child, idx) {
              param[child['name']] = child['model'] || ''
              if (child['name'] == 'schoolid') {
                param[child['name']] = that.curSchoolid
              }
              if (child['name'] == 'oldschoolid') {
                param[child['name']] = that.curSchoolid
              }
              if (child['name'] == 'item') {
                param[child['name']] = child['model'] || 0
              }
              if (child['name'] == 'id') {
                param[child['name']] = child['model'] || 0
              }
              if (child['name'] == 'calflag') {
                param['flag'] = 1
              }
              if (child['name'] == 'calfpid') {
                param['pid'] = val['guid']
              }
            })
            break
          case 'video':
            param[val['name']] = that.videoUrl
            break
          case 'select':
            param[val['name']] = val['model']
            break
          case 'switch':
            var model = val['model'] == true ? 1 : 0
            param[val['name']] = model
            break
          case 'selectMutl':
            param[val['name']] = val['model'].join(',')
            break
          case 'partuser':
            //console.log(that.checkPartUser)
            break
          case 'uploadimg':
            //console.log(that.storeimg,'111111')
            param[val['name']] = val['model'] || ''
            if (that.storeimg && that.storeimg.length > 0) {
              for (var i = 0; i < that.storeimg.length; i++) {
                param[that.storeimg[i]['name']] = that.storeimg[i]['children'][0]['picsmall']
              }
            }
            break
          case 'uploadpic':
            param[val['name']] = that.selfUrl
            break
          case 'todolist':
            var item = that.todolistdata
            var starttime = []
            var endtime = []
            var detialguid = []
            var deleteFlag = []
            item.map(function (val, index) {
              starttime.push(val['model'][0])
              endtime.push(val['model'][1])
              detialguid.push(val['guid'])
            })

            param['starttime'] = starttime.join(',')
            param['endtime'] = endtime.join(',')
            param['detialguid'] = detialguid.join(',')
            break
          default:
            param[val['name']] = val['model'] || ''
        }
      })


      if (['dataview/save.do'].indexOf(this.formdata[0][1]) > -1) {
        if (param['bedoismore'] == 1) {
          var classids = param['classid'].split(',')
          classids.map(function (val, index) {
            param['classid'] = val
            //console.log(param)
            that.axios.post(that.formdata[0][1], param).then(res => {

              if (res.success && index == classids.length - 1) {
                that.$Message.success(res.msg)
                that.showModal = false
                that.$emit('reloadModalData', true)
                if (that.$refs['videoUpload']) {
                  that.$refs['videoUpload'][0].clearFiles()
                }

              }
            })
          })
        } else {
          that.axios.post(that.formdata[0][1], param).then(res => {

            if (res.success) {
              that.$Message.success(res.msg)
              that.showModal = false
              that.$emit('reloadModalData', true)
              if (that.$refs['videoUpload']) {
                that.$refs['videoUpload'][0].clearFiles()
              }

            }
          })
        }
      } else {
        that.axios.post(that.formdata[0][1], param).then(res => {

          if (res.success) {
            that.$Message.success(res.msg)
            that.showModal = false
            that.$emit('reloadModalData', true)
            if (that.$refs['videoUpload']) {
              that.$refs['videoUpload'][0].clearFiles()
            }

          }
        })
      }

    },
    formateVal (data, isnew) {

      var that = this
      if (isnew != -1) {
        for (var key in data) {
          if (['isparent', 'isscreen', 'unshared', 'islock', 'ispublic'].indexOf(key) > -1) {
            data[key] = data[key] == 0 ? false : true
          }
          if (['notice', 'title', 'content'].indexOf(key) > -1) {
            data[key] = decodeURIComponent(data[key])
          }
          if (['selUser'].indexOf(key) > -1) {
            that.targetKeys = data[key]
          }
        }

        that.renderData(data)
      } else {

        that.formdata[1] = data
      }
    },
    changeClass (val) {

      this.formdata[1][0]['model'] = val['classid']
    },
    renderUser (val, index, child) {
      this.btnAct = index
      var that = this
      // that.axios.get('depart/loadDepartUser', {params:{departid:val}}).then((back) => {

      child.map(function (val, index) {
        val['label'] = val['name']
        val['key'] = val['guid']
      })

      that.users = child

      // })
    },
    changeUser (val, c, d) {

      this.targetKeys = val
      this.choseUserGroup = JSON.parse(JSON.stringify(this.targetKeys))
    },
    getMember (schoolid) {
      var that = this

      that.axios.get('webUser/dataList', {
        params: {
          schoolid: schoolid,
          legnth: -1,
        }
      }).then((a) => {
        that.allUser = a
      })

    },
    getPartData (schoolid) {
      var that = this
      var person = []
      utils.getPartData(schoolid).then(back => {
        var a = JSON.parse(back)

        that.b_part = a
        if (localStorage.getItem('inch_partUserData') != null && localStorage.getItem('inch_partUserData') != 'null' && localStorage.getItem('inch_partUserData') != '') {
          var users = that.partUserData = JSON.parse(localStorage.getItem('inch_partUserData'))

          users.map(function (val, index) {
            person.push(val['children'])
          })
          that.b_user = person
        } else {
          a.map(function (user, index) {
            that.axios.get('depart/loadDepartUser', {
              params: { departid: user.id }
            }).then((b) => {
              //localStorage.setItem("inch_partUserData", JSON.stringify(a))
              person.push(b)
              user['children'] = b
            })
          })

          that.partUserData = a
          that.b_user = person
          localStorage.setItem('inch_partUserData', JSON.stringify(a))
        }


      })



    },
    formateTime (data, type) {
      if (!data) {
        return ''
      }
      var d = new Date(data);
      var month = (d.getMonth() + 1) > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
      var date = d.getDate() > 9 ? d.getDate() : '0' + d.getDate()
      var hours = d.getHours() > 9 ? d.getHours() : '0' + d.getHours()
      var minutes = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()
      var seconds = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds()
      var time = d.getFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes

      if (type == 1) {
        return d.getFullYear() + '-' + month + '-' + date
      }
      return time
    },
    renderData (data) {
      var _currentData = this.formdata[1]
      var that = this
      for (var i = 0; i < _currentData.length; i++) {

        if (['checkbox', 'hidden'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['children'].map(function (val, index) {
            val['model'] = data[val['name']]
          })
        } else if (['rangetime'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = []
          _currentData[i]['model'].push(data['begintime'])
          _currentData[i]['model'].push(data['endtime'])
        } else if (['select', 'switch'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = data[_currentData[i]['name']]
        } else if (['uploadpic'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = that.selfUrl = data[_currentData[i]['name']] || ''
        } else if (['date'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = data[_currentData[i]['name']] || ''
        } else if (['todolist'].indexOf(_currentData[i]['type']) > -1) {
          var list = data['detialList']
          var children = []
          list.map(function (val, index) {
            children.push({ model: [val['starttime'], val['endtime']], guid: val['guid'] })
          })
          _currentData[i]['children'] = children

        } else if (_currentData[i]['name']) {
          _currentData[i]['model'] = data[_currentData[i]['name']] || ''

        }

      }


      return _currentData
    },
    cancelModal () {
      this.showModal = false
    },
    getUrlParam (str) {
      // 创建目标对象
      var obj = {}
      var params = str.split("?")[1]

      params = params.split("&")

      params.map(function (val, index) {

        var _key = val.split('=')[0], _val = val.split('=')[1];

        obj[_key] = _val
      })

      return obj
    },
    upVideo (a, b, c) {

      if (this.$refs['videoUpload'][0].fileList.length > 1) {
        this.$refs['videoUpload'][0].fileList.splice(0, 1)
      }
      //this.$refs['videoUpload'][0].clearFiles()
      this.videoUrl = a.url
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '请选择mp4格式文件'
      });
    },
    pichandleSuccess (res) {

      if (res[res.length - 1] && res[res.length - 1].response) {
        this.selfUrl = res[res.length - 1].response.url.split("@")[0]
      } else {
        this.selfUrl = ''
      }

    },
    getPhotoList () {

    },

  },
  filters: {
    formatepic (item) {

      return item.split(",")
    }
  }
}
</script>

<style scoped>
.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 30%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.pickerview {
  overflow: visible;
}

.pickerview .ivu-date-picker {
  float: left;
}

.pickerview .ivu-date-picker:last-of-type {
  float: right;
}

.remove {
  position: absolute;
  left: 0px;
  top: 0px;
}

.ivu-form-item.act {
  clear: both;
}

form:nth-of-type(odd) .ivu-form-item.nor {
  width: 48%;
  float: left;
}

form:nth-of-type(even) .ivu-form-item.nor {
  width: 48%;
  float: right;
}

#partGroup[data-v-70d15d9b] {
  margin-top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  clear: both;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

#partGroup .ivu-btn {
  margin: 8px 8px 8px 0px
}

#partGroup .ivu-btn-success {
  background: #fff;
  color: #515a6e;
  border: 1px solid #c5c8ce;
}

#partGroup .ivu-btn-success.active,
.ivu-btn-success:active {
  background-color: #47cb89 !important;
  border-color: #47cb89 !important;
  color: #fff;
}

#partGroup .btnNor {
  background-color: #edfcf6;
  color: #00d186;
  border: 1px solid #00d186;
}
</style>
